import React from 'react';

import { ConditionsContext } from './ConditionsContext';

export const useConditions = () => React.useContext(ConditionsContext);
